import {
  BANK_LIST_START,
  BANK_LIST_SUCCESS,
  BANK_LIST_FAILURE,
  CREATE_RECIPIENT_START,
  CREATE_RECIPIENT_SUCCESS,
  CREATE_RECIPIENT_FAILURE,
  RECIPIENT_LIST_START,
  RECIPIENT_LIST_SUCCESS,
  RECIPIENT_LIST_FAILURE,
  DELETE_RECIPIENT_START,
  DELETE_RECIPIENT_SUCCESS,
  DELETE_RECIPIENT_FAILURE,
  UPDATE_RECIPIENT_STATUS_START,
  UPDATE_RECIPIENT_STATUS_SUCCESS,
  UPDATE_RECIPIENT_STATUS_FAILURE,
  SINGLE_RECIPIENT_START,
  SINGLE_RECIPIENT_SUCCESS,
  SINGLE_RECIPIENT_FAILURE,
  MOBILE_CODES_LIST_START,
  MOBILE_CODES_LIST_SUCCESS,
  MOBILE_CODES_LIST_FAILURE,
  VIRTUAL_ACCOUNT_SHOW_START,
  VIRTUAL_ACCOUNT_SHOW_SUCCESS,
  VIRTUAL_ACCOUNT_SHOW_FAILURE,
  VIRTUAL_ACCOUNT_WITHDRAW_START,
  VIRTUAL_ACCOUNT_WITHDRAW_SUCCESS,
  VIRTUAL_ACCOUNT_WITHDRAW_FAILURE,
} from "../actions/ActionConstant";
import { createRecipientFailure } from "../actions/RecipientAction";

const initialState = {
  bankList: {
    data: {},
    loading: true,
    buttonDisable: false,
    error: false,
  },
  createRecipient: {
    data: {},
    loading: false,
    buttonDisable: false,
    error: false,
  },
  recipientList: {
    data: {},
    loading: false,
    buttonDisable: false,
    error: false,
  },
  updateRecipientStatus: {
    data: {},
    loading: false,
    buttonDisable: false,
    error: false,
  },
  deleteRecipient: {
    data: {},
    loading: false,
    buttonDisable: false,
    error: false,
  },
  singleRecipient: {
    data: {},
    loading: false,
    buttonDisable: false,
    error: false,
  },
  mobileCodesList: {
    data: {},
    loading: false,
    buttonDisable: false,
    error: false,
  },
  virtualAccountShow: {
    data: {},
    loading: false,
    buttonDisable: false,
    error: false,
  },
  virtualAccountWithdraw: {
    data: {},
    loading: false,
    buttonDisable: false,
    error: false,
  },
};

const RecipientReducer = (state = initialState, action) => {
  switch (action.type) {
    case BANK_LIST_START:
      return {
        ...state,
        bankList: {
          data: {},
          loading: true,
          error: false,
        },
      };
    case BANK_LIST_SUCCESS:
      return {
        ...state,
        bankList: {
          data: action.data,
          loading: false,
          error: false,
        },
      };
    case BANK_LIST_FAILURE:
      return {
        ...state,
        bankList: {
          data: {},
          loading: false,
          error: action.error,
        },
      };

    case CREATE_RECIPIENT_START:
      return {
        ...state,
        createRecipient: {
          data: {},
          loading: true,
          error: false,
        },
      };
    case CREATE_RECIPIENT_SUCCESS:
      return {
        ...state,
        createRecipient: {
          data: action.data,
          loading: false,
          error: false,
        },
      };
    case CREATE_RECIPIENT_FAILURE:
      return {
        ...state,
        createRecipient: {
          data: {},
          loading: false,
          error: action.error,
        },
      };

    case RECIPIENT_LIST_START:
      return {
        ...state,
        recipientList: {
          data: {},
          loading: true,
          error: false,
        },
      };
    case RECIPIENT_LIST_SUCCESS:
      return {
        ...state,
        recipientList: {
          data: action.data,
          loading: false,
          error: false,
        },
      };
    case RECIPIENT_LIST_FAILURE:
      return {
        ...state,
        recipientList: {
          data: {},
          loading: false,
          error: action.error,
        },
      };

      case UPDATE_RECIPIENT_STATUS_START:
      return {
        ...state,
        updateRecipientStatus: {
          data: {},
          loading: true,
          error: false,
          buttonDisable: true,
        },
      };
    case UPDATE_RECIPIENT_STATUS_SUCCESS:
      return {
        ...state,
        updateRecipientStatus: {
          data: action.data,
          loading: false,
          error: false,
          buttonDisable: false,
        },
      };
    case UPDATE_RECIPIENT_STATUS_FAILURE:
      return {
        ...state,
        updateRecipientStatus: {
          data: {},
          loading: false,
          error: action.error,
          buttonDisable: false,
        },
      };

      case DELETE_RECIPIENT_START:
        return {
          ...state,
          deleteRecipient: {
            data: {},
            loading: true,
            error: false,
            buttonDisable: true,
          },
        };
      case DELETE_RECIPIENT_SUCCESS:
        return {
          ...state,
          deleteRecipient: {
            data: action.data,
            loading: false,
            error: false,
            buttonDisable: false,
          },
        };
      case DELETE_RECIPIENT_FAILURE:
        return {
          ...state,
          deleteRecipient: {
            data: {},
            loading: false,
            error: action.error,
            buttonDisable: false,
          },
        };

    case SINGLE_RECIPIENT_START:
      return {
        ...state,
        singleRecipient: {
          data: {},
          loading: true,
          error: false,
        },
      };
    case SINGLE_RECIPIENT_SUCCESS:
      return {
        ...state,
        singleRecipient: {
          data: action.data,
          loading: false,
          error: false,
        },
      };
    case SINGLE_RECIPIENT_FAILURE:
      return {
        ...state,
        singleRecipient: {
          data: {},
          loading: false,
          error: action.error,
        },
      };

    case MOBILE_CODES_LIST_START:
      return {
        ...state,
        mobileCodesList: {
          data: {},
          loading: true,
          error: false,
        },
      };
    case MOBILE_CODES_LIST_SUCCESS:
      return {
        ...state,
        mobileCodesList: {
          data: action.data,
          loading: false,
          error: false,
        },
      };
    case MOBILE_CODES_LIST_FAILURE:
      return {
        ...state,
        mobileCodesList: {
          data: {},
          loading: false,
          error: action.error,
        },
      };

    case VIRTUAL_ACCOUNT_SHOW_START:
      return {
        ...state,
        virtualAccountShow: {
          data: {},
          loading: true,
          error: false,
        },
      };
    case VIRTUAL_ACCOUNT_SHOW_SUCCESS:
      return {
        ...state,
        virtualAccountShow: {
          data: action.data,
          loading: false,
          error: false,
        },
      };
    case VIRTUAL_ACCOUNT_SHOW_FAILURE:
      return {
        ...state,
        virtualAccountShow: {
          data: {},
          loading: false,
          error: action.error,
        },
      };


    case VIRTUAL_ACCOUNT_WITHDRAW_START:
      return {
        ...state,
        virtualAccountWithdraw: {
          data: {},
          loading: true,
          error: false,
          buttonDisable: true,
        },
      };
    case VIRTUAL_ACCOUNT_WITHDRAW_SUCCESS:
      return {
        ...state,
        virtualAccountWithdraw: {
          data: action.data,
          loading: false,
          error: false,
          buttonDisable: false,
        },
      };
    case VIRTUAL_ACCOUNT_WITHDRAW_FAILURE:
      return {
        ...state,
        virtualAccountWithdraw: {
          data: {},
          loading: false,
          error: action.error,
          buttonDisable: false,
        },
      };


    default:
      return state;
  }
};

export default RecipientReducer;
